"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrentUser = exports.CurrentUserHandler = void 0;
const link_navigation_handler_1 = require("../navigation/link-navigation-handler");
const user_status_enum_1 = require("./user-status-enum");
class CurrentUserHandler {
    constructor() {
        this.registeredUserNavigationHandler = this.defaultUserNavigationHandler;
    }
    get User() {
        return this.user;
    }
    get DefaultUserNavigationHandler() {
        return this.defaultUserNavigationHandler;
    }
    static getInstance() {
        if (!CurrentUserHandler.instance) {
            CurrentUserHandler.instance = new CurrentUserHandler();
        }
        return CurrentUserHandler.instance;
    }
    setCurrentUser(user) {
        this.user = user;
    }
    registerUserNavigationHandler(userNavigationHandler) {
        this.registeredUserNavigationHandler = userNavigationHandler || this.defaultUserNavigationHandler;
    }
    onCurrentUserChanged(subscriber) {
        window.addEventListener(CurrentUserHandler.CURRENT_USER_CHANGED_EVENT, ((event) => {
            subscriber(event.detail);
        }));
    }
    triggerCurrentUserChanged(userData) {
        window.dispatchEvent(new CustomEvent(CurrentUserHandler.CURRENT_USER_CHANGED_EVENT, {
            detail: userData
        }));
        this.registeredUserNavigationHandler(userData);
    }
    defaultUserNavigationHandler(userStatusChangeEvent) {
        const isAuthenticated = userStatusChangeEvent &&
            userStatusChangeEvent.userStatus !== user_status_enum_1.UserStatus.UNKNOWN &&
            userStatusChangeEvent.userStatus !== user_status_enum_1.UserStatus.NO_SESSION;
        if (isAuthenticated) {
            if (userStatusChangeEvent.url) {
                link_navigation_handler_1.LinkNavigator.triggerNavigation({
                    detail: {
                        href: userStatusChangeEvent.url
                    }
                });
            }
        }
        else if (userStatusChangeEvent.url && userStatusChangeEvent.logoutEvent) {
            link_navigation_handler_1.LinkNavigator.triggerNavigation({
                detail: {
                    href: userStatusChangeEvent.url
                }
            });
        }
    }
}
exports.CurrentUserHandler = CurrentUserHandler;
CurrentUserHandler.CURRENT_USER_CHANGED_EVENT = 'current-user-changed-event';
exports.CurrentUser = CurrentUserHandler.getInstance();
//# sourceMappingURL=current-user-handler.js.map